export default __webpack_public_path__ + "static/media/postSuvinil8.59c5fb48.gif";